import * as e from "react";
import { forwardRef as r } from "react";
const L = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M13.6822 4.21589C14.2436 4.7815 15.1586 4.7815 15.72 4.21589L17.8669 6.37882L6.33168 18L4.18474 15.8371C4.74617 15.2715 4.74617 14.3497 4.18474 13.7841C3.62331 13.2185 2.70837 13.2185 2.14694 13.7841L0 11.6212L11.5353 0L13.6822 2.16294C13.1208 2.72855 13.1208 3.65028 13.6822 4.21589ZM8.59297 11.0451C9.00365 11.4588 9.66904 11.4588 10.0797 11.0451C10.6931 10.4219 10.7503 9.23306 10.7555 8.73029C10.7555 7.77713 10.7451 7.17486 10.7451 7.17486C10.7451 7.17486 10.1473 7.16439 9.20118 7.16439C8.70213 7.16439 7.5221 7.22201 6.90349 7.84523C6.49282 8.25896 6.49282 8.92931 6.90349 9.34304C7.17381 9.61537 7.55328 9.7044 7.89637 9.62061C7.92757 9.62061 7.95878 9.62585 7.98477 9.65203C8.02636 9.68869 8.03153 9.75154 7.99515 9.78296C7.74562 9.97673 7.07506 10.4009 6.39926 10.0919L7.84961 11.5531C7.5429 10.8723 7.96395 10.1967 8.15629 9.94531C8.18748 9.90865 8.24987 9.91914 8.28625 9.95579C8.31225 9.98198 8.32264 10.0134 8.31744 10.0448C8.22907 10.3905 8.32266 10.7728 8.59297 11.0451ZM9.15441 8.36875L9.97574 7.94977L9.55467 8.77725L10.2097 9.43189L9.29475 9.29048L8.87888 10.118L8.73334 9.20146L7.81842 9.05482L8.64495 8.63061L8.49941 7.71411L9.15441 8.36875Z",
        fill: "#000",
        fillRule: "evenodd"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 18, width: 18 })))
  );
});
export {
  L as FreeBetSb
};
